var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"picker"},[_c('canvas',{ref:"canvas",staticStyle:{"pointer-events":"all"},attrs:{"width":_vm.width * 5,"height":_vm.height * 5},on:{"mousedown":_vm.dragStart,"mousemove":_vm.dragMove,"mouseup":_vm.dragEnd}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cad8ad56","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PointPicker.vue
// module id = null
// module chunks = 